import * as React from 'react';
import { StepProps, Step } from '@material-ui/core';

export type DSStepProps = StepProps;

export function DSStep(props: DSStepProps): JSX.Element {
    return <Step {...props}>{props.children}</Step>;
}
DSStep.displayName = 'DSStep';
